<template>
  <BaseTemplate >
    <div class="bg_white pt16 pb16 boxs1">
        <GeneralTitle :title="'セミナールーム利用申請(予約)'" />
        <dl class="data mt20 pl16 pr16">
          <div class="data_list">
            <dt class="data_title ab">利用するサロン</dt>
            <dd class="data_text ab">{{ getSalonContents().salonName }}</dd>
          </div>
          <div class="data_list">
            <dt class="data_title ab">利用する部屋</dt>
            <dd class="data_text ab">{{ getRoomContents().roomName }}</dd>
          </div>
          <div class="data_list">
            <dt class="data_title ab">開催日</dt>
            <dd class="data_text rb">{{ formatDate(getBussinesDayContents().businessDay) }}</dd>
          </div>
          <div class="data_list">
            <dt class="data_title ab">利用開始時間</dt>
            <dd class="data_text rb">{{ getStartTImeContents().hhMM }}</dd>
          </div>
          <div class="data_list">
            <dt class="data_title ab">利用終了時間</dt>
            <dd class="data_text rb">{{ getEndTImeContents().hhMM }}</dd>
          </div>
        </dl>
    </div>

    <div class="organizer mt16 bg_white pt16 pb16 boxs1">
      <GeneralTitle :title="'主催者(代表者)情報'" />
      <div class="pl16 pr16">
        <div class="organizer_wrap">
          <div class="title_wrap mt26">
            <SidebarTitle :title="'主催者会員番号'" />
            <div class="status required">必須</div>
          </div>
          <div class="input_wrap mt16">
            <input type="number" class="input_text ab" placeholder="1234567" :value="SEMINAR_INFO.organizerMemberId1" @input="updateOrganizerMemberId1" />
            <p class="caution_text ar">7桁の会員番号をご入力ください。</p>
          </div>
        </div>
        <div class="organizer_wrap">
          <div class="title_wrap mt26">
            <SidebarTitle :title="'主催者氏名'" />
            <div class="status required">必須</div>
          </div>
          <div class="input_wrap mt16">
            <input type="text" class="input_text ab" placeholder="ナチュラリー太郎" :value="SEMINAR_INFO.organizerMemberName1" @input="updateOrganizerMemberName1" />
            <ul class="caution_list pl16">
              <li class="caution_text ar">公式ホームページ「セミナー情報」に掲載しますのでお間違いのないようにご入力をお願いします。 </li>
              <li class="caution_text ar">法人登録の方は代表者の方のお名前をご入力ください。 </li>
            </ul>
          </div>
        </div>

        <div class="organizer_wrap">
          <div class="title_wrap mt26">
            <SidebarTitle :title="'主催者電話番号'" />
            <div class="status required">必須</div>
          </div>
          <div class="input_wrap mt16">
            <input type="tel" class="input_text ab" placeholder="0120989329" :value="SEMINAR_INFO.organizerMemberTel1" @input="updateOrganizerMemberTel1" />
            <ul class="caution_list pl16">
              <!-- <li class="caution_text ar">ハイフンなしでご入力ください。（0120989329） </li> -->
              <li class="caution_text ar">公式ホームページ「セミナー情報」に掲載しますのでお間違いのないようにご入力をお願いします。 </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="other">
        <div class="toggle_wrap ml16 mr16">
          <button class="organizer_toggle ab" @click="isOrganizerToggle ? isOrganizerToggle = false : isOrganizerToggle = true">※主催の方が複数いる場合</button>
        </div>
        <div v-if="isOrganizerToggle">
          <div class="other_instructor mt22">
            <div class="other_wrap">
              <GeneralTitle :title="'主催者②'" />
              <div class="pl16 pr16">
                <div class="organizer_wrap">
                  <div class="title_wrap mt26">
                    <SidebarTitle :title="'主催者会員番号'" />
                    <div class="status">任意</div>
                  </div>
                  <div class="input_wrap mt16">
                    <input type="number" class="input_text ab" placeholder="1234567" :value="SEMINAR_INFO.organizerMemberId2" @input="updateOrganizerMemberId2" />
                    <p class="caution_text ar">7桁の会員番号をご入力ください。</p>
                  </div>
                </div>
                <div class="organizer_wrap">
                  <div class="title_wrap mt26">
                    <SidebarTitle :title="'主催者氏名'" />
                    <div class="status">任意</div>
                  </div>
                  <div class="input_wrap mt16">
                    <input type="text" class="input_text ab" placeholder="ナチュラリー太郎" :value="SEMINAR_INFO.organizerMemberName2" @input="updateOrganizerMemberName2" />
                    <ul class="caution_list pl16">
                      <li class="caution_text ar">公式ホームページ「セミナー情報」に掲載しますのでお間違いのないようにご入力をお願いします。 </li>
                      <li class="caution_text ar">法人登録の方は代表者の方のお名前をご入力ください。 </li>
                    </ul>
                  </div>
                </div>

                <div class="organizer_wrap">
                  <div class="title_wrap mt26">
                    <SidebarTitle :title="'主催者電話番号'" />
                    <div class="status">任意</div>
                  </div>
                  <div class="input_wrap mt16">
                    <input type="number" class="input_text ab" placeholder="0120989329" :value="SEMINAR_INFO.organizerMemberTel2" @input="updateOrganizerMemberTel2" />
                    <ul class="caution_list pl16">
                      <li class="caution_text ar">ハイフンなしでご入力ください。（0120989329） </li>
                      <li class="caution_text ar">公式ホームページ「セミナー情報」に掲載しますのでお間違いのないようにご入力をお願いします。 </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="other_wrap">
              <GeneralTitle :title="'主催者③'" />
              <div class="pl16 pr16">
                <div class="organizer_wrap">
                  <div class="title_wrap mt26">
                    <SidebarTitle :title="'主催者会員番号'" />
                    <div class="status">任意</div>
                  </div>
                  <div class="input_wrap mt16">
                    <input type="number" class="input_text ab" placeholder="1234567" :value="SEMINAR_INFO.organizerMemberId3" @input="updateOrganizerMemberId3" />
                    <p class="caution_text ar">7桁の会員番号をご入力ください。</p>
                  </div>
                </div>
                <div class="organizer_wrap">
                  <div class="title_wrap mt26">
                    <SidebarTitle :title="'主催者氏名'" />
                    <div class="status">任意</div>
                  </div>
                  <div class="input_wrap mt16">
                    <input type="text" class="input_text ab" placeholder="ナチュラリー太郎" :value="SEMINAR_INFO.organizerMemberName3" @input="updateOrganizerMemberName3" />
                    <ul class="caution_list pl16">
                      <li class="caution_text ar">公式ホームページ「セミナー情報」に掲載しますのでお間違いのないようにご入力をお願いします。 </li>
                      <li class="caution_text ar">法人登録の方は代表者の方のお名前をご入力ください。 </li>
                    </ul>
                  </div>
                </div>

                <div class="organizer_wrap">
                  <div class="title_wrap mt26">
                    <SidebarTitle :title="'主催者電話番号'" />
                    <div class="status">任意</div>
                  </div>
                  <div class="input_wrap mt16">
                    <input type="number" class="input_text ab" placeholder="0120989329" :value="SEMINAR_INFO.organizerMemberTel3" @input="updateOrganizerMemberTel3" />
                    <ul class="caution_list pl16">
                      <li class="caution_text ar">ハイフンなしでご入力ください。（0120989329） </li>
                      <li class="caution_text ar">公式ホームページ「セミナー情報」に掲載しますのでお間違いのないようにご入力をお願いします。 </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <div class="organizer mt16 bg_white pt16 pb16 boxs1">
        <GeneralTitle :title="'セミナー情報'" />
        <div class="pl16 pr16">
          <div class="organizer_wrap">
            <div class="title_wrap mt26">
              <SidebarTitle :title="'セミナー名称'" />
              <div class="status required">必須</div>
            </div>
            <div class="input_wrap mt16">
              <input type="text" class="input_text ab" placeholder="セミナータイトル" :value="SEMINAR_INFO.title" @input="updateTitle" />
              <ul class="caution_list pl16">
                <li class="caution_text ar">セミナータイトルをご入力ください。（例）事業説明会、ビジネスセミナー など </li>
                <li class="caution_text ar">ご入力の内容によっては、変更させていただく場合がございます。 </li>
              </ul>
            </div>
          </div>

          <div class="organizer_wrap">
            <div class="title_wrap mt26">
              <SidebarTitle :title="'セミナー種別'" />
              <div class="status required">必須</div>
            </div>
            <div class="input_wrap mt16">
              <BaseSelect :value="SEMINAR_INFO.seminarType" @input="updateSeminarType" class="mt10">
                <option v-for="(val, index) in SEMINAR_TYPE_LIST" :value="val.seminarType" :key="index">{{ val.seminarTypeText }}</option>
              </BaseSelect>
            </div>
          </div>

          <div class="organizer_wrap">
            <div class="title_wrap mt26">
              <SidebarTitle :title="'セミナー開催時間'" />
              <div class="status required">必須</div>
            </div>
            <div class="initial_wrap">
              <div class="time_text">開始</div>
              <div class=""></div>
              <div class="time_text">終了</div>
            </div>
            <div class="time">
              <div class="time_wrap">
                <div class="time_content">
                  <BaseSelect :value="SEMINAR_INFO.hourFrom" @input="updateSelectedStartListHour" :fontStyle="'rb'" :size="'small'" class="time_select">
                    <option v-for="(val, index) in filteredStartList" :value="val.hour" class="select_text rb" :key="index">{{ val.hour }}</option>
                  </BaseSelect>

                  <span class="time_initial ab">：</span>

                  <BaseSelect :value="SEMINAR_INFO.minuteFrom" @input="updateSelectedStartListMinute" :fontStyle="'rb'" :size="'small'" class="time_select">
                      <option v-for="(val, index) in flattenedStartTimes(filteredStartList)" :value="val.minute" class="select_text rb" :key="index">{{ val.text }}</option>
                  </BaseSelect>
                </div>
              </div>
              <span class="time_from_to ab">～</span>

              <div class="time_wrap">
                <div class="time_content">
                  <BaseSelect :value="SEMINAR_INFO.hourTo" @input="updateSelectedEndListHour" :fontStyle="'rb'" :size="'small'" class="time_select">
                    <option v-for="(val, index) in filteredEndList" :value="val.hour" class="select_text rb" :key="index">{{ val.hour }}</option>
                  </BaseSelect>

                  <span class="time_initial ab">：</span>

                  <BaseSelect :value="SEMINAR_INFO.minuteTo" @input="updateSelectedEndListMinute" :fontStyle="'rb'" :size="'small'" class="time_select">
                      <option v-for="(val, index) in flattenedEndTimes(filteredEndList)" :value="val.minute" class="select_text rb" :key="index">{{ val.text }}</option>
                  </BaseSelect>
                </div>

              </div>
            </div>
          </div>

          <div class="organizer_wrap">
            <div class="title_wrap mt26">
              <SidebarTitle :title="'受講料有無'" />
              <div class="status required">必須</div>
            </div>
            <div class="input_wrap mt16">
              <BaseSelect :value="SEMINAR_INFO.paid === true ? 'true' : 'false'" @input="updatePaid" class="mt10">
                <option value="true">有料</option>
                <option value="false">無料</option>
              </BaseSelect>
            </div>
          </div>

          <div v-if="SEMINAR_INFO.paid === true" class="organizer_wrap">
            <div class="title_wrap mt26">
              <SidebarTitle :title="'受講料'" />
              <div class="status required">必須</div>
            </div>
            <div class="input_wrap mt16">
              <input type="text" class="input_text ab" placeholder="1234円" :value="SEMINAR_INFO.courseFee" @input="updateCourseFee" />
              <ul class="caution_list pl16">
                <li class="caution_text ar">有料セミナーの場合、ご利用時間に応じた利用料をお支払いいただきます。</li>
                <li class="caution_text ar">利用料は、セミナールーム利用規約をご確認ください。 </li>
                <li class="caution_text ar">お支払いはサロンでお願いいたします。 </li>
                <li class="caution_text ar">利用規約は下記資料にて、ご確認ください。 </li>
              </ul>
            </div>
          </div>
          <div class="organizer_wrap terms">
            <h2 class="terms_title ab">セミナールーム利用規約</h2>
            <div class="btn_wrap mt24">
              <a :href="showTermsOfService()" class="btn btn_yellow" target="_blank" rel="noopener noreferrer">規約を表示</a>
            </div>
          </div>

          <div class="organizer_wrap remark">
            <div class="title_wrap">
              <SidebarTitle :title="'備考(内容)'" />
              <div class="status">任意</div>
            </div>
            <div class="input_wrap mt16">
              <textarea :value="SEMINAR_INFO.remark" @input="updateRemark" name="" id="" rows="5" maxlength="100" class="textarea"></textarea>
              <p class="remarks_info ab">※補足説明があればご入力ください（100文字まで）</p>
            </div>
          </div>

        </div>
    </div>

    <div class="organizer mt16 bg_white pt16 pb16 boxs1">
      <GeneralTitle :title="'講師情報'" />
      <div class="pl16 pr16">
        <div class="organizer_wrap">
          <div class="title_wrap mt26">
            <SidebarTitle :title="'講師会員番号'" />
            <div class="status required">必須</div>
          </div>
          <div class="input_wrap mt16">
            <input type="number" class="input_text ab" placeholder="1234567" :value="SEMINAR_INFO.instructorMemberId1" @input="updateInstructorMemberId1" />
            <p class="caution_text ar">7桁の会員番号をご入力ください。</p>
          </div>
        </div>

        <div class="organizer_wrap">
          <div class="title_wrap mt26">
            <SidebarTitle :title="'講師氏名'" />
            <div class="status required">必須</div>
          </div>
          <div class="input_wrap mt16">
            <input type="text" class="input_text ab" placeholder="ナチュラリー太郎" :value="SEMINAR_INFO.instructorMemberName1" @input="updateInstructorMemberName1" />
            <ul class="caution_list pl16">
              <li class="caution_text ar">公式ホームページ「セミナー情報」に掲載しますのでお間違いのないようにご入力をお願いします。 </li>
              <li class="caution_text ar">法人登録の方は代表者の方のお名前をご入力ください。 </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="other">
        <div class="toggle_wrap ml16 mr16">
          <button class="organizer_toggle ab" @click="isInstructorToggle ? isInstructorToggle = false : isInstructorToggle = true">※講師の方が複数いる場合</button>
        </div>
        <div v-if="isInstructorToggle">
          <div class="other_instructor mt22">
            <div class="other_wrap">
              <GeneralTitle :title="'講師②'" />
              <div class="pl16 pr16">
                <div class="organizer_wrap">
                  <div class="title_wrap mt26">
                    <SidebarTitle :title="'講師会員番号'" />
                    <div class="status">任意</div>
                  </div>
                  <div class="input_wrap mt16">
                    <input type="number" class="input_text ab" placeholder="1234567" :value="SEMINAR_INFO.instructorMemberId2" @input="updateInstructorMemberId2" />
                    <p class="caution_text ar">7桁の会員番号をご入力ください。</p>
                  </div>
                </div>

                <div class="organizer_wrap">
                  <div class="title_wrap mt26">
                    <SidebarTitle :title="'講師氏名'" />
                    <div class="status">任意</div>
                  </div>
                  <div class="input_wrap mt16">
                    <input type="text" class="input_text ab" placeholder="ナチュラリー太郎" :value="SEMINAR_INFO.instructorMemberName2" @input="updateInstructorMemberName2" />
                    <ul class="caution_list pl16">
                      <li class="caution_text ar">公式ホームページ「セミナー情報」に掲載しますのでお間違いのないようにご入力をお願いします。 </li>
                      <li class="caution_text ar">法人登録の方は代表者の方のお名前をご入力ください。 </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="other_wrap">
            <GeneralTitle :title="'講師③'" />
            <div class="pl16 pr16">
              <div class="organizer_wrap">
                <div class="title_wrap mt26">
                  <SidebarTitle :title="'講師会員番号'" />
                  <div class="status">任意</div>
                </div>
                <div class="input_wrap mt16">
                  <input type="number" class="input_text ab" placeholder="1234567" :value="SEMINAR_INFO.instructorMemberId3" @input="updateInstructorMemberId3" />
                  <p class="caution_text ar">7桁の会員番号をご入力ください。</p>
                </div>
              </div>

              <div class="organizer_wrap">
                <div class="title_wrap mt26">
                  <SidebarTitle :title="'講師氏名'" />
                  <div class="status">任意</div>
                </div>
                <div class="input_wrap mt16">
                  <input type="text" class="input_text ab" placeholder="ナチュラリー太郎" :value="SEMINAR_INFO.instructorMemberName3" @input="updateInstructorMemberName3" />
                  <ul class="caution_list pl16">
                    <li class="caution_text ar">公式ホームページ「セミナー情報」に掲載しますのでお間違いのないようにご入力をお願いします。 </li>
                    <li class="caution_text ar">法人登録の方は代表者の方のお名前をご入力ください。 </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
  <div class="bg_white mt16 pt32 pb48 boxs1">
    <div class="btn_wrap">
      <BaseBtn :btnText="'確認画面へ'" :type="'blue'" @onClick="onClickReservationConfirm" />
      <BaseBtn :style="{marginTop: '16px'}" :btnText="'戻る'" @onClick="onClickPageBackReservation" :type="'delete'"  />
    </div>
  </div>

    <BaseModal v-if="isModarOpen">
      <div v-for="(value, index) in messageList" class="ab error_text" :key="index">{{ value }}</div>
      <div class="mt16">
        <BaseBtn :btnText="'閉じる'" :type="'delete'" @onClick="onClickCloseModal" />
      </div>
    </BaseModal>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationHelper } from '@/helper';
import Config from '@/config/config';
import SalonApi from '@/components/api/salon/reservation';
import BaseTemplate from '@/views/common/BaseTemplate.vue';
import GeneralTitle from '@/components/common/GeneralTitle.vue';
import BaseBtn from '@/components/common/BaseBtn.vue';
import BaseModal from '@/components/common/BaseModal.vue';
import SidebarTitle from '@/components/common/SidebarTitle.vue';
import BaseSelect from '@/components/common/BaseSelect.vue';

export default {
  components: {
      GeneralTitle,
      BaseTemplate,
      BaseBtn,
      BaseModal,
      SidebarTitle,
      BaseSelect
  },
  data() {
      return {
          Config: Config,
          messageList: [],
          termCheck: false,
          isModarOpen: false,
          isOrganizerToggle: false,
          isInstructorToggle: false,
          filteredStartList: [],
          filteredEndList: [],
      }
  },
  methods: {
    formatDate(dateStr) {
      let date = new Date(dateStr);
      let year = date.getFullYear(); // 年を取得
      let month = date.getMonth() + 1; // 月を取得（0から始まるので+1）
      let day = date.getDate(); // 日を取得

      // 曜日を取得（0（日曜）から6（土曜）までの数値）
      let weekdayNumber = date.getDay();
      let weekday = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"][weekdayNumber];

      let formattedDate = `${year}年${month}月${day}日 ${weekday}`;

      return formattedDate;
    },
    flattenedTimes(hourlist, selectedValue) {
        if(selectedValue == '') return [];
        const minuteList = hourlist.find((val) => {
          return val.hour == selectedValue;
        });
        if(!minuteList) return [];
        return minuteList.minuteList;
    },
    flattenedStartTimes(startList) {
        console.log('startList', startList);
        if(startList.length == 0) return [];
        let selectedHour = parseInt(this.SEMINAR_INFO.hourFrom)
        const selectedList = startList.find((val) => {
          return val.hour == selectedHour;
        });
        if(this.SEMINAR_INFO.hourFrom == this.RESERVATION_SELECTED_END_LIST_HOUR) {
          return selectedList.minuteList.filter(item => {
            return item.minute < this.RESERVATION_SELECTED_END_LIST_MINUTE;
          });
        }

        if(this.SEMINAR_INFO.hourFrom != this.RESERVATION_SELECTED_START_LIST_HOUR) {
          return selectedList.minuteList;
        }

        return selectedList.minuteList.filter(item => {
          return item.minute >= this.RESERVATION_SELECTED_START_LIST_MINUTE;
        });
    },
    flattenedEndTimes(endList) {
        console.log('endList', endList);
        if(endList.length == 0) return [];
        let selectedHour = parseInt(this.SEMINAR_INFO.hourTo)
        const selectedList = endList.find((val) => {
          return val.hour == selectedHour;
        });
        if(this.SEMINAR_INFO.hourTo != this.RESERVATION_SELECTED_END_LIST_HOUR) {
          return selectedList.minuteList;
        }
        return selectedList.minuteList.filter(item => {
          return item.minute <= this.RESERVATION_SELECTED_END_LIST_MINUTE;
        });
    },
    updateStartList(startHour) {
        startHour = parseInt(startHour);
        this.filteredStartList = this.RESERVATION_START_LIST.filter(item => {
          return item.hour >= startHour && item.hour <= this.RESERVATION_SELECTED_END_LIST_HOUR;
        });
    },
    updateEndList(endHour) {
      let startHour = parseInt(this.RESERVATION_SELECTED_START_LIST_HOUR);
      endHour = parseInt(endHour);
      let startMinute = parseInt(this.RESERVATION_SELECTED_START_LIST_MINUTE);

      this.filteredEndList = this.RESERVATION_END_LIST.filter(item => {
        if (item.hour < startHour || item.hour > endHour) {
          return false;
        }

        if (item.hour == startHour) {
          if (startMinute == 45) {
            return false;
          }
          return item.minuteList.some(minuteItem => minuteItem.minute > startMinute);
        }
        return true;
      });
    },
    resetStartSeminarTimeToInvaild() {
      // const startList = this.filteredStartList.find(item => item.hour == parseInt(this.SEMINAR_INFO.hourFrom));
      const filterList = this.flattenedStartTimes(this.filteredStartList);
      let timeResult = filterList.some(item => item.minute == parseInt(this.SEMINAR_INFO.minuteFrom));
      if(!timeResult) {
        this.updateSelectedStartListMinute('');
      }
    },
    resetEndSeminarTimeToInvaild() {
      // const startList = this.filteredStartList.find(item => item.hour == parseInt(this.SEMINAR_INFO.hourFrom));
      const filterList = this.flattenedEndTimes(this.filteredEndList);
      let timeResult = filterList.some(item => item.minute == parseInt(this.SEMINAR_INFO.minuteTo));
      if(!timeResult) {
        this.updateSelectedEndListMinute('');
      }
    },
    showTermsOfService() {
      return `${Config.APIURL}/api/salon/reservation/showTermsOfService?salonId=${this.RESERVATION_SELECTED_SALON_ID}&openExternalBrowser=1`;
    },
    getSalonContents() {
      const salonData = this.RESERVATION_SALON_LIST.find((val) => {
        return val.salonId == this.RESERVATION_SELECTED_SALON_ID;
      });

      if(!salonData) return '';
      return salonData;
    },
    getRoomContents() {
      const roomData = this.RESERVATION_ROOM_LIST.find((val) => {
        return val.roomId == this.RESERVATION_SELECTED_ROOM_ID;
      });

      if(!roomData) return '';
      return roomData;
    },
    getBussinesDayContents() {
      const bussinesDayData = this.RESERVATION_BUSINESS_DAY_LIST.find((val) => {
        return val.businessDay == this.RESERVATION_SELECTED_BUSINESS_DAY;
      });

      if(!bussinesDayData) return '';
      return bussinesDayData;
    },
    getStartTImeContents() {
      const hourData = this.RESERVATION_START_LIST.find((val) => {
        return val.hour == this.RESERVATION_SELECTED_START_LIST_HOUR;
      });

      if(!hourData) return '';
      const minuteData = hourData.minuteList.find((value) => {
        return value.minute == this.RESERVATION_SELECTED_START_LIST_MINUTE;
      });

      if(!minuteData) return '';
      return minuteData;
    },
    getEndTImeContents() {
      const hourData = this.RESERVATION_END_LIST.find((val) => {
        return val.hour == this.RESERVATION_SELECTED_END_LIST_HOUR;
      });

      if(!hourData) return '';
      const minuteData = hourData.minuteList.find((value) => {
        return value.minute == this.RESERVATION_SELECTED_END_LIST_MINUTE;
      });

      if(!minuteData) return '';
      return minuteData;
    },

    onClickReservationConfirm() {
      console.log(this.SEMINAR_INFO);
      if(this.SEMINAR_INFO.organizerMemberId1 == '') {
        this.messageList.push('主催者管理番号が入力されていません。');
      }
      if(this.SEMINAR_INFO.organizerMemberId1.length != 7) {
        this.messageList.push('主催者管理番号は7桁で入力してください。');
      }
      if(this.SEMINAR_INFO.organizerMemberName1 == '') {
        this.messageList.push('主催者氏名が入力されていません。');
      }
      if(!ValidationHelper.validatePhoneNumber(this.SEMINAR_INFO.organizerMemberTel1)) {
        this.messageList.push('11桁の番号をご入力ください');
      }

      // 主催者が複数いる場合名前が入力されていれば電話番号のチェックを行う
      if(this.SEMINAR_INFO.organizerMemberName2 != '') {
        if(!ValidationHelper.validatePhoneNumber(this.SEMINAR_INFO.organizerMemberTel2)) {
          this.messageList.push('11桁の番号をご入力ください');
        }
      }
      if(this.SEMINAR_INFO.organizerMemberName3 != '') {
        if(!ValidationHelper.validatePhoneNumber(this.SEMINAR_INFO.organizerMemberTel3)) {
          this.messageList.push('11桁の番号をご入力ください');
        }
      }


      if(this.SEMINAR_INFO.title == '') {
        this.messageList.push('セミナー名称が入力されていません。');
      }
      if(this.SEMINAR_INFO.seminarType == '') {
        this.messageList.push('セミナー種別が選択されていません。');
      }

      if(this.SEMINAR_INFO.hourFrom == '' || this.SEMINAR_INFO.minuteFrom == '') {
        this.messageList.push('セミナー開始時間を選択してください。');
      }

      if(this.SEMINAR_INFO.hourTo == '' || this.SEMINAR_INFO.minuteTo == '') {
        this.messageList.push('セミナー終了時間を選択してください。');
      }
      // 終了時間が開始時間よりも前であるかをチェック
      const startTotalMinutes = parseInt(this.SEMINAR_INFO.hourFrom) * 60 + parseInt(this.SEMINAR_INFO.minuteFrom);
      const endTotalMinutes = parseInt(this.SEMINAR_INFO.hourTo) * 60 + parseInt(this.SEMINAR_INFO.minuteTo);
      if (startTotalMinutes >= endTotalMinutes) {
        this.messageList.push('終了時間は開始時間よりも後に設定してください');
      }
      // paid
      if(this.SEMINAR_INFO.paid == null) {
        this.messageList.push('受講料有無が選択されていません。');
      }
      if(this.SEMINAR_INFO.courseFee && this.SEMINAR_INFO.courseFee == '') {
        this.messageList.push('受講料が入力されていません。');
      }
      // instructorMemberId1：講師会員番号
      if(this.SEMINAR_INFO.instructorMemberId1 == '') {
        this.messageList.push('講師会員番号が入力されていません。');
      }
      if(this.SEMINAR_INFO.instructorMemberId1.length != 7) {
        this.messageList.push('講師会員番号は7桁で入力してください。');
      }
      if(this.SEMINAR_INFO.instructorMemberName1 == '') {
        this.messageList.push('講師氏名が入力されていません。');
      }

      if(this.messageList.length > 0) {
          this.isModarOpen = true;
          return;
      }
      this.$router.push({ name: 'ReservationConfirm', query: { backUrl: 'ReservationSeminar' } });


    },

    updateOrganizerMemberId1(newOrganizerMemberId1) {
      if(newOrganizerMemberId1.target.value.length > 7) return;
      this.$store.commit('salon/SEMINAR_SET_INFO_ORGANIZER_MEMBER_ID1', newOrganizerMemberId1.target.value);
    },
    updateOrganizerMemberName1(newOrganizerMemberName1) {
      this.$store.commit('salon/SEMINAR_SET_INFO_ORGANIZER_MEMBER_NAME1', newOrganizerMemberName1.target.value);
    },
    updateOrganizerMemberTel1(newOrganizerMemberTel1) {
      this.$store.commit('salon/SEMINAR_SET_INFO_ORGANIZER_MEMBER_TEL1', newOrganizerMemberTel1.target.value);
    },
    updateOrganizerMemberId2(newOrganizerMemberId2) {
      if(newOrganizerMemberId2.target.value.length > 7) return;
      this.$store.commit('salon/SEMINAR_SET_INFO_ORGANIZER_MEMBER_ID2', newOrganizerMemberId2.target.value);
    },
    updateOrganizerMemberName2(newOrganizerMemberName2) {
      this.$store.commit('salon/SEMINAR_SET_INFO_ORGANIZER_MEMBER_NAME2', newOrganizerMemberName2.target.value);
    },
    updateOrganizerMemberTel2(newOrganizerMemberTel2) {
      this.$store.commit('salon/SEMINAR_SET_INFO_ORGANIZER_MEMBER_TEL2', newOrganizerMemberTel2.target.value);
    },
    updateOrganizerMemberId3(newOrganizerMemberId3) {
      if(newOrganizerMemberId3.target.value.length > 7) return;
      this.$store.commit('salon/SEMINAR_SET_INFO_ORGANIZER_MEMBER_ID3', newOrganizerMemberId3.target.value);
    },
    updateOrganizerMemberName3(newOrganizerMemberName3) {
      this.$store.commit('salon/SEMINAR_SET_INFO_ORGANIZER_MEMBER_NAME3', newOrganizerMemberName3.target.value);
    },
    updateOrganizerMemberTel3(newOrganizerMemberTel3) {
      this.$store.commit('salon/SEMINAR_SET_INFO_ORGANIZER_MEMBER_TEL3', newOrganizerMemberTel3.target.value);
    },
    updateTitle(newTitle) {
      this.$store.commit('salon/SEMINAR_SET_INFO_TITLE', newTitle.target.value);
    },
    updateSeminarType(newSeminarType) {
      this.$store.commit('salon/SEMINAR_SET_INFO_SEMINAR_TYPE', newSeminarType);
    },
    updatePaid(newPaid) {
      this.$store.commit('salon/SEMINAR_SET_INFO_PAID', newPaid);
    },
    updateCourseFee(newCourseFee) {
      this.$store.commit('salon/SEMINAR_SET_INFO_COURSE_FEE', newCourseFee.target.value);
    },
    updateRemark(newRemark) {
      this.$store.commit('salon/SEMINAR_SET_INFO_REMARK', newRemark.target.value);
    },
    updateInstructorMemberId1(newInstructorMemberId1) {
      this.$store.commit('salon/SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_ID1', newInstructorMemberId1.target.value);
    },
    updateInstructorMemberName1(newInstructorMemberName1) {
      this.$store.commit('salon/SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_NAME1', newInstructorMemberName1.target.value);
    },
    updateInstructorMemberId2(newInstructorMemberId2) {
      this.$store.commit('salon/SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_ID2', newInstructorMemberId2.target.value);
    },
    updateInstructorMemberName2(newInstructorMemberName2) {
      this.$store.commit('salon/SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_NAME2', newInstructorMemberName2.target.value);
    },
    updateInstructorMemberId3(newInstructorMemberId3) {
      this.$store.commit('salon/SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_ID3', newInstructorMemberId3.target.value);
    },
    updateInstructorMemberName3(newInstructorMemberName3) {
      this.$store.commit('salon/SEMINAR_SET_INFO_INSTRUCTOR_MEMBER_NAME3', newInstructorMemberName3.target.value);
    },
    updateSelectedStartListHour(newStartHour) {
      this.$store.commit('salon/SEMINAR_SET_INFO_HOUR_FROM', newStartHour);
      this.updateStartList(this.RESERVATION_SELECTED_START_LIST_HOUR);
      this.resetStartSeminarTimeToInvaild();
    },
    updateSelectedStartListMinute(newStartMinute) {
      console.log(newStartMinute);
      if(newStartMinute == undefined) return;
      this.$store.commit('salon/SEMINAR_SET_INFO_MINUTE_FROM', newStartMinute);
    },
    updateSelectedEndListHour(newEndHour) {
      this.$store.commit('salon/SEMINAR_SET_INFO_HOUR_TO', newEndHour);
      this.updateEndList(this.RESERVATION_SELECTED_END_LIST_HOUR);
      this.resetEndSeminarTimeToInvaild();
    },
    updateSelectedEndListMinute(newEndMinute) {
      this.$store.commit('salon/SEMINAR_SET_INFO_MINUTE_TO', newEndMinute);
    },

    onClickPageBackReservation() {
      this.$router.push({name: 'Reservation'});
    },
    onClickCloseModal() {
      this.isModarOpen = false;
      this.messageList = [];
    },
    onClickPageBack() {
      this.$router.push({name: this.$route.query.backUrl});
    },
    async apiGetSeminarTypeList() {
      await SalonApi.getSeminarTypeList().then((val) => {
        this.$store.commit('salon/SEMINAR_SET_TYPE_LIST', val);
      });
    },

  },
  async created() {
      this.apiGetSeminarTypeList();
      console.log('created');
      console.log(this.SEMINAR_INFO);
      if(this.SEMINAR_INFO.hourFrom != '' && this.SEMINAR_INFO.minuteFrom != '' && this.SEMINAR_INFO.hourTo != '' && this.SEMINAR_INFO.minuteTo != '') {
        this.updateSelectedStartListHour(this.SEMINAR_INFO.hourFrom);
        this.updateSelectedStartListMinute(this.SEMINAR_INFO.minuteFrom);
        this.updateSelectedEndListHour(this.SEMINAR_INFO.hourTo);
        this.updateSelectedEndListMinute(this.SEMINAR_INFO.minuteTo);
      } else  {
        this.updateSelectedStartListHour(this.RESERVATION_SELECTED_START_LIST_HOUR);
        this.updateSelectedStartListMinute(this.RESERVATION_SELECTED_START_LIST_MINUTE);
        this.updateSelectedEndListHour(this.RESERVATION_SELECTED_END_LIST_HOUR);
        this.updateSelectedEndListMinute(this.RESERVATION_SELECTED_END_LIST_MINUTE);
      }


  },
  computed: mapGetters(
    'salon', [
      'RESERVATION_SALON_LIST',
      'RESERVATION_SELECTED_SALON_ID',
      'RESERVATION_BUSINESS_DAY_LIST',
      'RESERVATION_SELECTED_BUSINESS_DAY',
      'RESERVATION_ROOM_LIST',
      'RESERVATION_SELECTED_ROOM_ID',
      'RESERVATION_START_LIST',
      'RESERVATION_SELECTED_START_LIST_HOUR',
      'RESERVATION_SELECTED_START_LIST_MINUTE',
      'RESERVATION_END_LIST',
      'RESERVATION_SELECTED_END_LIST_HOUR',
      'RESERVATION_SELECTED_END_LIST_MINUTE',
      'SEMINAR_INFO',
      'SEMINAR_TYPE_LIST',
    ],
  ),
}
</script>

<style lang="css" scoped>
.data {
  margin-top: 20px;
}

.data_list {
  align-items: flex-start;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  line-height: 1;
}
.data_list:not(:first-child) {
  margin-top: 14px;
}
.data_title,
.data_text {
  width: 45%;
}
.data_text {
  display: flex;
  justify-content: flex-end;
  text-align: right;
}

.organizer_wrap.remark {
  margin-top: 64px;
}
.organizer .title_wrap {
  margin-top: 26px;
}
.title_wrap {
  align-items: center;
  display: flex;
}
.status {
  background-color: #fff;
  border: 1px solid #72C785;
  border-radius: 5px;
  color: #72C785;
  font-size: 12px;
  line-height: 1;
  margin-left: 8px;
  padding: 4px 8px;
}
.status.required {
  background-color: #FF0000;
  border: 1px solid #FF0000;
  color: #fff;
}

.input_wrap .input_text {
  border: none;
  border-bottom: 1px solid #C9C9C9;
  display: block;
  font-size: 16px;
  padding: 16px 0;
  width: 100%;
}
.caution_text {
  color: #878787;
  font-size: 12px;
  margin-top: 8px;
}
.caution_list {
  list-style: disc;
}
.textarea {
  border: 1px solid #C9C9C9;
  border-radius: 5px;
  padding: 8px;
  width: 100%;
}
.remarks_info {
  font-size: 12px;
}

.terms {
  margin-top: 36px;
}
.terms .terms_title {
  font-size: 12px;
  text-align: center;
}

.toggle_wrap {
  position: relative;
}
.toggle_wrap::after {
  align-items: center;
  bottom: 0;
  content: '\f078';
  color: #636366;
  display: flex;
  font-size: 18px;
  font-family: "Font Awesome 5 Free","Font Awesome 5 Brands";
  font-weight: 900;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.organizer_toggle {
  background-color: transparent;
  border: none;
  font-size: 16px;
  padding: 8px 0;
  text-align: left;
  width: 100%;
}
.other_wrap:not(:first-child) {
  margin-top: 56px;
}

.initial_wrap {
  display: grid;
  grid-template-columns: 1fr 48px 1fr;
}
.initial_wrap .time_text {
  margin-top: 16px;
  width: 50%;
}
.time {
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 48px 1fr;
}
.time_content {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 36px 1fr;
}

.time_initial {
    font-size: 16px;
    text-align: center;
}
.time_text {
  color: #878787;
  font-size: 12px;
}
.time_from_to {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/salon/ReservationSeminar.vue